export default "__VITE_ASSET__c6a89b6f__"